import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { getToken } from './Utils/Common';
import PageLayout from './Layouts/PageLayout/PageLayout';
import UserLayout from './Layouts/UserLayout/UserLayout';
import AdminLayout from './Layouts/AdminLayout/AdminLayout';
import Structure from './Layouts/Structure/Structure';
import QRCode from './Pages/QRCode/QRCode';
import Home from './Pages/Home/Home';
import Product from './Pages/Product/Product';
import About from './Pages/About/About';
import ContactUs from './Pages/ContactUs/ContactUs';
import PrivacyPolicy from './Pages/PrivacyPolicy/PrivacyPolicy';
import FAQs from './Pages/FAQs/FAQs';
import Pricing from './Pages/Pricing/Pricing';
import Blog from './Pages/Blog/Blog';
import PowerOfQRCode from './Pages/Blog/PowerOfQRCode';
import QRCodeScannersEducation from './Pages/Blog/QRCodeScannersEducation';
import EnvironmentalImpactOfQRCodes from './Pages/Blog/EnvironmentalImpactOfQRCodes';
import PapertoPixel from './Pages/Blog/PapertoPixel';
import CreatingQRCodeForYourWebsite from './Pages/Blog/CreatingQRCodeForYourWebsite';
import HowQRCodesWorkAndDecodeInformation from './Pages/Blog/HowQRCodesWorkAndDecodeInformation';
import Login from './User/Login/Login';
import MyQRCodes from './User/MyQRCodes/MyQRCodes';
import MyQRCodeDetail from './User/MyQRCodeDetail/MyQRCodeDetail';
import CreateQRCode from './User/CreateQRCode/CreateQRCode';
import Profile from './User/Profile/Profile';
import RequestCallback from './User/RequestCallback/RequestCallback';
import Plans from './User/Plans/Plans';
import Logout from './User/Logout/Logout';
import AdminLogin from './Admin/Login/Login';
import AdminDashboard from './Admin/Dashboard/Dashboard';
import AdminUsers from './Admin/Users/Users';
import AdminUserDetail from './Admin/Users/UserDetail';
import AdminQRCategory from './Admin/QRCategory/QRCategory';
import AdminServices from './Admin/Services/Services';
import AdminLogout from './Admin/Logout/Logout';
import VerifyEmail from './User/ActionPages/VerifyEmail';
import ChangePassword from './User/ActionPages/ChangePassword';
import BharatBioScience from './User/ActionPages/BharatBioScience';
import ProductInfo from './User/ActionPages/ProductInfo';

function App() {
    // Function to check if the user is authenticated
    const isUserAuthenticated = () => {
        if(getToken()){
            return true;
        } else {
            return false;
        }
    };
    
    const PrivateRouteWrapper = ({ element }) => {
        // If the user is not authenticated, redirect to the login page
        if (!isUserAuthenticated()) {
            return <Navigate to="/login" />;
        }
      
        // Render the private route if the user is authenticated
        return element;
    };

    const PublicRouteWrapper = ({ element }) => {
        // If the user is authenticated, redirect to the dashboard page
        if (isUserAuthenticated()) {
            return <Navigate to="/my-qr-codes" />;
        }
      
        // Render the public route if the user is not authenticated
        return element;
    };

    return (<>
        <BrowserRouter>
            <Routes>
                <Route path='/structure' element={<Structure />} />
                {/* ========== Website pages ========== */}
                <Route exact path='/' element={<PageLayout><QRCode /></PageLayout>} />
                <Route path='/home' element={<PageLayout><Home /></PageLayout>} />
                <Route path='/product' element={<PageLayout><Product /></PageLayout>} />
                <Route path='/about' element={<PageLayout><About /></PageLayout>} />
                <Route path='/contact-us' element={<PageLayout><ContactUs /></PageLayout>} />
                <Route path='/privacy-policy' element={<PageLayout><PrivacyPolicy /></PageLayout>} />
                <Route path='/faqs' element={<PageLayout><FAQs /></PageLayout>} />
                <Route path='/pricing' element={<PageLayout><Pricing /></PageLayout>} />

                {/* ========== Blog pages ========== */}
                <Route path='/blog' element={<PageLayout><Blog /></PageLayout>} />
                <Route path='/blog/unlock-the-Power-of-qr-codes' element={<PageLayout><PowerOfQRCode /></PageLayout>} />
                <Route path='/blog/qr-code-scanners-in-education' element={<PageLayout><QRCodeScannersEducation /></PageLayout>} />
                <Route path='/blog/environmental-impact-of-qr-codes' element={<PageLayout><EnvironmentalImpactOfQRCodes /></PageLayout>} />
                <Route path='/blog/paper-to-pixel' element={<PageLayout><PapertoPixel /></PageLayout>} />
                <Route path='/blog/creating-qrcode-for-your-website' element={<PageLayout><CreatingQRCodeForYourWebsite /></PageLayout>} />
                <Route path='/blog/how-qr-codes-work-and-decode-information' element={<PageLayout><HowQRCodesWorkAndDecodeInformation /></PageLayout>} />
                
                {/* ========== Dashboard pages ========== */}
                <Route path="/login" element={<PublicRouteWrapper element={<Login />} />} />
                <Route path='/my-qr-codes' element={<UserLayout><PrivateRouteWrapper element={<MyQRCodes />} /></UserLayout>} />
                <Route path='/qr-code-detail' element={<UserLayout><PrivateRouteWrapper element={<MyQRCodeDetail />} /></UserLayout>} />
                <Route path='/create-qr-code' element={<UserLayout><PrivateRouteWrapper element={<CreateQRCode />} /></UserLayout>} />
                <Route path='/profile' element={<UserLayout><PrivateRouteWrapper element={<Profile />} /></UserLayout>} />
                <Route path='/request-callback' element={<UserLayout><PrivateRouteWrapper element={<RequestCallback />} /></UserLayout>} />
                <Route path='/plans' element={<UserLayout><PrivateRouteWrapper element={<Plans />} /></UserLayout>} />
                <Route path='/logout' element={<Logout />} />

                {/* ========== Action pages ========== */}
                <Route path='/verify-email/:string' element={<VerifyEmail />} />
                <Route path='/change-password/:string' element={<ChangePassword />} />
                <Route path='/bharat-bio-science/:string' element={<BharatBioScience />} />
                <Route path='/product-info/:string' element={<ProductInfo />} />
                
                {/* ========== Admin pages ========== */}
                <Route path='/admin/login' element={<AdminLogin />} />
                <Route path='/admin/dashboard' element={<AdminLayout><AdminDashboard /></AdminLayout>} />
                <Route path='/admin/users' element={<AdminLayout><AdminUsers /></AdminLayout>} />
                <Route path='/admin/user-detail' element={<AdminLayout><AdminUserDetail /></AdminLayout>} />
                <Route path='/admin/qr-category' element={<AdminLayout><AdminQRCategory /></AdminLayout>} />
                <Route path='/admin/services' element={<AdminLayout><AdminServices /></AdminLayout>} />
                <Route path='/admin/logout' element={<AdminLayout><AdminLogout /></AdminLayout>} />
            </Routes>
        </BrowserRouter>
    </>);
}

export default App;